const _excluded = ["children", "className", "footer", "header", "style", "minWidth", "maxWidth", "minHeight", "maxHeight", "width", "height", "hideCloseBtn", "onClose", "disableContentScroll", "fullSizeHeader", "headerClassName", "disableFooterPadding", "contentUseFullWidth", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import cn from 'classnames';
import { CloseButton } from "../CloseButton";
import { useDevice } from "../Device";
import styles from "./CustomModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CustomModal(props) {
  const {
      children,
      className,
      footer,
      header,
      style,
      minWidth,
      maxWidth = 1198,
      minHeight,
      maxHeight = '90vh',
      width,
      height,
      hideCloseBtn,
      onClose,
      disableContentScroll = false,
      fullSizeHeader = false,
      headerClassName,
      disableFooterPadding,
      contentUseFullWidth = false,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    isMobileDevice
  } = useDevice();
  const renderedStyle = useMemo(() => _objectSpread(_objectSpread({}, style), {}, {
    minWidth,
    maxWidth: isMobileDevice ? '90%' : maxWidth,
    minHeight,
    maxHeight,
    height,
    width
  }), [style, minWidth, maxWidth, minHeight, maxHeight, height, width, isMobileDevice]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    style: renderedStyle,
    className: cn(styles.root, {
      [styles.withHeader]: header
    }, className),
    "data-testid": testId,
    children: [!hideCloseBtn && /*#__PURE__*/_jsx(CloseButton, {
      className: styles.closeBtn,
      skin: "transparent",
      testId: testId && "".concat(testId, "-close-btn"),
      onClick: onClose
    }), header && /*#__PURE__*/_jsx("div", {
      className: cn(styles.header, {
        [styles.fullSizeHeader]: fullSizeHeader
      }, headerClassName),
      children: header
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles.content, {
        [styles.disableOverflow]: disableContentScroll,
        [styles.contentUseFullWidth]: contentUseFullWidth
      }),
      children: children
    }), footer && /*#__PURE__*/_jsx("div", {
      className: cn(styles.footer, {
        [styles.disablePadding]: disableFooterPadding
      }),
      children: footer
    })]
  }));
}